import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";
import socityone from "../images/socityone.webp";
import socitytwo from "../images/socitytwo.webp";
import socityhree from "../images/Achievment.jpg";
// import picture1 from "../images/Picture1.png";
// import picture2 from "../images/Picture2.png";
// import picture3 from "../images/Picture3.png";
function students() {
  return (
    <>
      <Header />
      <section
        class="content-section title-top"
        style={{ backgroundImage: `url(${topback})` }}
      >
        <div class="pattern-overlay">
          <div class="container">
            <div class="row">
              <div class="col-lg-12 title-heading">
                <h2>Our Achievements</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
              <div className="container mt-5 pt-5 pb-5">
          {/* Notice 1 */}
          <div className="row align-items-center mb-5">
            <div className="col-md-6 how-img">
              {/* <img
                src={picture1}
                className="img-fluid rounded"
                alt="Rajya Puraskar"
              /> */}
            </div>
            <div className="col-md-6">
              <h4>SDWG GOVT.COLLEGE BEETAN: Rajya Puraskar</h4>
              <h5 className="subheading">REPORT DATED: 2024-25</h5>
              <p className="text-muted">
                We are proud to announce that <strong>Ms. Naina</strong>, a
                dedicated Ranger from Beetan College, has successfully achieved
                the prestigious <strong>Rajya Puraskar</strong>. This
                recognition is awarded by the Bharat Scouts and Guides
                organization to Rangers who have demonstrated exceptional
                commitment, service, and leadership. Her achievement reflects
                her perseverance, discipline, and active participation in
                national-level scouting initiatives. Congratulations to Ms.
                Naina for this remarkable accomplishment.
              </p>
            </div>
          </div>

          {/* Notice 2 */}
          <div className="row align-items-center mb-5 flex-md-row-reverse">
            <div className="col-md-6 how-img">
              {/* <img
                src={picture2}
                className="img-fluid rounded"
                alt="GEM Exam"
              /> */}
            </div>
            <div className="col-md-6">
              <h4>Crack GEM Exam</h4>
              <h5 className="subheading">REPORT DATED: 2024</h5>
              <p className="text-muted">
                <strong>Mr. Chirag</strong>, B.Sc 2nd Year student at Beetan
                College, secured an impressive{" "}
                <strong>All India Rank 499</strong> in the GEM Exam 2024.
                Achieving this top 500 position is a testament to his academic
                excellence, analytical abilities, and consistent hard work. The
                college congratulates him and wishes continued success.
              </p>
            </div>
          </div>

          {/* Notice 3 */}
          <div className="row align-items-center mb-5">
            <div className="col-md-6 how-img">
              {/* <img
                src={picture3}
                className="img-fluid rounded"
                alt="Thal Sena Camp"
              /> */}
            </div>
            <div className="col-md-6">
              <h4>Thal Sena Camp</h4>
              <h5 className="subheading">REPORT DATED: 11-20 July 2025</h5>
              <p className="text-muted">
                NCC Cadet <strong>Heena</strong> represented 6 HP Coy (I) NCC
                Una at the 10-day Inter Group Competition / Thal Sena Camp
                (IGC/TSC) held at Ropar. She actively participated in Obstacle
                Race and Tent Pitching events, showcasing discipline, endurance,
                and team spirit. Her conduct was exemplary and appreciated by
                camp authorities.
              </p>
            </div>
          </div>
        </div>
    <div className="container mt-5 pt-5 pb-5">
  {/* Mock Interview Session */}
  <div className="row align-items-center mb-5 flex-md-row-reverse">
    <div className="col-md-6 how-img">
      <img src={socityone} className="img-fluid rounded" alt="Mock Interview Session" />
    </div>
    <div className="col-md-6">
      <h4>SDWG GOVT.COLLEGE BEETAN MOCK INTERVIEW SESSION</h4>
      <h5 className="subheading">REPORT DATED: 10/11/2023</h5>
      <p className="text-muted">
        A mock interview session was organized on November 10, 2023, in the conference hall. Dr. Anjori Sharma, principal of the college, gave a welcome address and apprised the participants about the objective and purpose of this mock interview session. She asserted that the mock interview sessions will benefit students' future career-related skills and job opportunities. The mock interview session panel was headed by Prof. Gurdev S.
      </p>
    </div>
  </div>

  {/* Drama Competition */}
  <div className="row align-items-center mb-5">
    <div className="col-md-6 how-img">
      <img src={socitytwo} className="img-fluid rounded" alt="Drama Competition" />
    </div>
    <div className="col-md-6">
      <h4>RED Ribbon Club</h4>
      <h5 className="subheading">REPORT DATED: [Date]</h5>
      <p className="text-muted">
        Our college drama team got second position in the district-level drama competition organized by CMO Una to spread awareness about HIV/AIDS.
      </p>
    </div>
  </div>

  {/* Additional Event */}
  <div className="row align-items-center mb-5 flex-md-row-reverse">
    <div className="col-md-6 how-img">
      <img src={socityhree} className="img-fluid rounded" alt="Event Image" />
    </div>
    <div className="col-md-6">
      <h4></h4>
      <h5 className="subheading"></h5>
      <p className="text-muted">
        
      </p>
    </div>
  </div>
</div>

      <Footer />
    </>
  );
}

export default students;
